import constants from 'constants/index'
import theme from 'theme'

const formChipColor = (status) => {
  return (
    (status && constants.consent.CONSENT_FORM_STATUS_CHIP_COLOR[status]) ||
    theme.palette.secondary.light
  )
}

export default formChipColor
